module.exports = __webpack_public_path__ + "static/media/1_en.9bb8c5f9.png";